import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../../services/analyticsService';

const PAGE_TITLES = {
  '/': 'Inicio',
  '/productos': 'Catálogo de Productos',
  '/carrito': 'Carrito de Compras',
  '/checkout': 'Checkout',
  '/login': 'Iniciar Sesión',
  '/payment-result': 'Resultado de Pago',
  '/mis-pagos': 'Mis Pagos',
  '/pedidos': 'Mis Pedidos',
  '/perfil': 'Mi Perfil',
};

// Rutas con parámetros, que por definición no caben en el mapa de arriba. El
// orden importa: se usa el primer patrón que coincide.
const PAGE_PATTERNS = [
  // Acepta id numérico y slug: desde que las fichas viven en
  // /producto/exploding-kittens-edicion-original, un patrón de solo dígitos
  // dejaba de casar y todas las visitas a fichas se registraban con la ruta
  // cruda como título, rompiendo el informe de páginas.
  { pattern: /^\/producto\/[A-Za-z0-9-]+$/, title: 'Ficha de Producto' },
  { pattern: /^\/admin(\/|$)/, title: 'Admin Panel' },
  { pattern: /^\/seguimiento(\/|$)/, title: 'Seguimiento de Pedido' },
];

/**
 * Resuelve el título legible de una ruta.
 *
 * No intenta incluir el nombre del producto: este tracker dispara en cuanto
 * cambia la ruta, antes de que la ficha haya resuelto su petición, y esperar
 * retrasaría o duplicaría el pageview. La identidad del producto va en la
 * page_url (/producto/<id>) y en el evento view_product.
 */
export function resolvePageTitle(pathname) {
  if (PAGE_TITLES[pathname]) return PAGE_TITLES[pathname];

  const match = PAGE_PATTERNS.find(({ pattern }) => pattern.test(pathname));
  if (match) return match.title;

  return pathname;
}

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    // Cerrar primero el tiempo de la página anterior: en una SPA el cambio
    // de ruta es la salida de esa página, y sin este reporte el tiempo solo
    // se registraba al ocultar o cerrar la pestaña — 148 medidas frente a
    // 19.000 pageviews. No hace nada en el primer montaje.
    analyticsService.trackPageExit();
    analyticsService.trackPageView(resolvePageTitle(path));
  }, [location.pathname]);

  return null;
}
